export { default as ContactInfoForm } from './conntent-info-form/contact-info-form.component';
export { default as LocationFormContent } from './location-form-content/location-form-content.component';
export { default as LocationFormContentOriginal } from './location-form-content-original/location-form-content-original.componet';
export { default as LocationMap } from './location-map/location-map.component';
export { default as SelectFormContent } from './select-form-content/select-form-content.component';
export { default as LocationMapForm } from './location-map-form/location-map-form.component';
